import Bugsnag from '@bugsnag/js';

const bugsnagMiddleware = store => next => action => {
    if (Bugsnag.isStarted()) {
        Bugsnag.leaveBreadcrumb(
            'Redux action',
            {
                type: action.type,
            },
            'state'
        );
    }

    return next(action);
};

export default bugsnagMiddleware;



// WEBPACK FOOTER //
// ./src/redux/bugsnagMiddleware.js